import ChangePasswordForm from '@/auth/components/ChangePasswordForm';
import SettingsSection from '@/components/SettingsSection';
import SecurityForm from '@/profile/components/forms/Security';

/**
 * ENG-6300: Settings → Sign-in & Security. How you sign in on one page: the
 * password, then (on a Cognito session) the connected Google and Microsoft
 * accounts, then two-factor verification. SecurityForm stays the last two
 * because the profile dialog renders it on its own and must not grow a password
 * section.
 */
export default function SignInSecurity(props: { userId?: string }): JSX.Element {
  return (
    <>
      <SettingsSection box title="Password">
        <ChangePasswordForm {...props} />
      </SettingsSection>
      <SecurityForm {...props} />
    </>
  );
}
